import dbUserFromUser from "../auth/DataApi"

export const navigateNext = async (currentUser, step) => {
    // Get user from db and update it too
    const dbUser = await dbUserFromUser({...currentUser, youknow: {navigation: {currentStep: step}}, misbolos: {groups: []}})
    if (dbUser) {
        return '/misbolos/' + step
    }else{
        console.warn('Navigate is not allowed if no user registered')
    }
}

export const navigateNextQuestion = async (currentUser, step) => {
    console.log('Navigating to next question ! no :(')
}
